import React from 'react';
import { Button } from './ui/button';
import { Twitter, Facebook, Linkedin, Link2, Mail } from 'lucide-react';
import { toast } from 'sonner';

const SocialShareButtons = ({ job, variant = 'default' }) => {
  const { job_id, title, company_name, location, license_required } = job;
  
  const jobUrl = `${window.location.origin}/jobs/${job_id}`;
  const hashtags = ['SocialWorkJobs', license_required, 'Hiring', 'SocialWorker'].filter(Boolean).join(',');
  
  const shareText = `🔔 Job Alert: ${title} at ${company_name} (${location}) - ${license_required} #SocialWorkJobs #${license_required}`;
  
  const shareLinks = {
    twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(jobUrl)}&hashtags=${hashtags}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(jobUrl)}&quote=${encodeURIComponent(shareText)}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(jobUrl)}`,
    email: `mailto:?subject=${encodeURIComponent(`Job Opportunity: ${title}`)}&body=${encodeURIComponent(`Check out this social work job:\n\n${title} at ${company_name}\nLocation: ${location}\nLicense: ${license_required}\n\nApply here: ${jobUrl}`)}`,
  };

  const handleShare = (platform) => {
    if (platform === 'copy') {
      navigator.clipboard.writeText(jobUrl);
      toast.success('Link copied to clipboard!');
      return;
    }
    window.open(shareLinks[platform], '_blank', 'width=600,height=400');
  };

  if (variant === 'compact') {
    return (
      <div className="flex items-center gap-1">
        <Button variant="ghost" size="icon" onClick={() => handleShare('twitter')} className="h-8 w-8 text-gray-500 hover:text-[#1DA1F2]">
          <Twitter className="w-4 h-4" />
        </Button>
        <Button variant="ghost" size="icon" onClick={() => handleShare('linkedin')} className="h-8 w-8 text-gray-500 hover:text-[#0A66C2]">
          <Linkedin className="w-4 h-4" />
        </Button>
        <Button variant="ghost" size="icon" onClick={() => handleShare('facebook')} className="h-8 w-8 text-gray-500 hover:text-[#1877F2]">
          <Facebook className="w-4 h-4" />
        </Button>
        <Button variant="ghost" size="icon" onClick={() => handleShare('copy')} className="h-8 w-8 text-gray-500 hover:text-primary">
          <Link2 className="w-4 h-4" />
        </Button>
      </div>
    );
  }

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-sm text-gray-500 mr-2">Share:</span>
      <Button 
        variant="outline" 
        size="sm" 
        onClick={() => handleShare('twitter')}
        className="text-[#1DA1F2] border-[#1DA1F2] hover:bg-[#1DA1F2] hover:text-white"
      >
        <Twitter className="w-4 h-4 mr-1" />
        Twitter
      </Button>
      <Button 
        variant="outline" 
        size="sm" 
        onClick={() => handleShare('linkedin')}
        className="text-[#0A66C2] border-[#0A66C2] hover:bg-[#0A66C2] hover:text-white"
      >
        <Linkedin className="w-4 h-4 mr-1" />
        LinkedIn
      </Button>
      <Button 
        variant="outline" 
        size="sm" 
        onClick={() => handleShare('facebook')}
        className="text-[#1877F2] border-[#1877F2] hover:bg-[#1877F2] hover:text-white"
      >
        <Facebook className="w-4 h-4 mr-1" />
        Facebook
      </Button>
      <Button 
        variant="outline" 
        size="sm" 
        onClick={() => handleShare('email')}
        className="text-gray-600 hover:bg-gray-600 hover:text-white"
      >
        <Mail className="w-4 h-4 mr-1" />
        Email
      </Button>
      <Button 
        variant="outline" 
        size="sm" 
        onClick={() => handleShare('copy')}
        className="text-primary border-primary hover:bg-primary hover:text-white"
      >
        <Link2 className="w-4 h-4 mr-1" />
        Copy Link
      </Button>
    </div>
  );
};

export default SocialShareButtons;
